import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useMemo, useContext } from 'react';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
const setupProps = props => {
  const onClickToCreate = (props === null || props === void 0 ? void 0 : props.onClickToCreate) || noop;
  return {
    onClickTime: (props === null || props === void 0 ? void 0 : props.onClickTime) || noop,
    onClickToCreate,
    onClickToCreateAvailable: onClickToCreate !== noop,
    onMouseMoveTime: (props === null || props === void 0 ? void 0 : props.onMouseMoveTime) || noop,
    timezone: (props === null || props === void 0 ? void 0 : props.timezone) || I18n.moment.tz.guess(),
    use: (props === null || props === void 0 ? void 0 : props.use) || 'WEEK',
    eventDisplay: (props === null || props === void 0 ? void 0 : props.eventDisplay) || ['all-day-events', 'events'],
    hideWeekends: (props === null || props === void 0 ? void 0 : props.hideWeekends) || false,
    hourHeight: props === null || props === void 0 ? void 0 : props.hourHeight,
    themeOverride: props === null || props === void 0 ? void 0 : props.themeOverride,
    displayYear: props === null || props === void 0 ? void 0 : props.displayYear,
    displayMonth: props === null || props === void 0 ? void 0 : props.displayMonth,
    displayDay: props === null || props === void 0 ? void 0 : props.displayDay,
    currentTime: props === null || props === void 0 ? void 0 : props.currentTime,
    compact: (props === null || props === void 0 ? void 0 : props.compact) || false
  };
};
export const calendarDefaultProps = setupProps();
const CalendarPropsContext = /*#__PURE__*/createContext(calendarDefaultProps);
export const CalendarPropsProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const contextValue = useMemo(() => setupProps(props), [props]);
  return /*#__PURE__*/_jsx(CalendarPropsContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useCalendarProps = () => {
  return useContext(CalendarPropsContext);
};
export const CalendarPropsConsumer = CalendarPropsContext.Consumer;